import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia'
import { computed, getCurrentInstance, nextTick, ref, watch } from 'vue'

import { TrackingService } from '@/client/services'
import { normalizeLineEndings } from '@/common/utils'

import { useCampaignMemoStore } from '../hooks/useCampaignMemoStore'
import { formatMemoCounter, getMemoErrorMessage, isMemoOverLimit } from '../utils/campaignMemoText'

interface Emits {
  (e: 'close'): void
  (e: 'saved'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CampaignMemoDialog',
  props: {
  visible: {
    type: Boolean,
    required: true
  },
  campaignId: {
    type: Number,
    default: null
  }
},
  emits: ["close", "saved"],
  setup(__props, { emit }: { emit: ({
  (e: 'close'): void
  (e: 'saved'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const { proxy } = getCurrentInstance() as any




const store = useCampaignMemoStore()
const { memo, fetching, saving } = storeToRefs(store)

const draft = ref('')
const textareaRef = ref<{ focus: () => void } | null>(null)

const normalizedDraft = computed(() => normalizeLineEndings(draft.value))
const counterText = computed(() => formatMemoCounter(draft.value))
const errorMessage = computed(() => getMemoErrorMessage(draft.value))
const canSave = computed(() => !isMemoOverLimit(draft.value))
const campaignTitle = computed(() => (memo.value ? memo.value.campaign_title || '' : ''))

watch(
  () => props.visible,
  async open => {
    if (!open || props.campaignId == null) {
      return
    }

    draft.value = ''

    try {
      await store.fetchMemo(props.campaignId)
      draft.value = memo.value ? memo.value.memo || '' : ''
      await nextTick()
      if (textareaRef.value) {
        textareaRef.value.focus()
      }
    } catch {
      proxy.$notify({
        title: 'キャンペーンメモの取得に失敗しました。',
        message: '恐れ入りますが、時間をおいて再度お試しください。',
        customClass: 'danger',
        duration: 5000
      })
      emit('close')
    }
  }
)

const handleSave = async (): Promise<void> => {
  if (!canSave.value || props.campaignId == null || saving.value) {
    return
  }
  TrackingService.sendEvent('click:キャンペーンメモ|保存')

  try {
    await store.saveMemo(props.campaignId, normalizedDraft.value)
    proxy.$notify({
      title: 'キャンペーンメモを保存しました。',
      customClass: 'success',
      duration: 5000
    })
    emit('saved')
  } catch {
    proxy.$notify({
      title: 'キャンペーンメモの保存に失敗しました。',
      message: '恐れ入りますが、時間をおいて再度お試しください。',
      customClass: 'danger',
      duration: 5000
    })
  }
}

const handleClose = (): void => {
  if (saving.value || fetching.value) {
    return
  }
  draft.value = ''
  emit('close')
}

return { __sfc: true,proxy, props, emit, store, memo, fetching, saving, draft, textareaRef, normalizedDraft, counterText, errorMessage, canSave, campaignTitle, handleSave, handleClose }
}

})